import { AuthProvider } from 'react-admin'
import { supabase } from './supabaseClient'

export const authProvider: AuthProvider = {
  login: async ({ email, password }) => {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })
    
    if (error) {
      throw new Error(error.message)
    }
    
    return Promise.resolve()
  },

  logout: async () => {
    const { error } = await supabase.auth.signOut()
    
    if (error) {
      throw new Error(error.message)
    }
    
    return Promise.resolve()
  },

  checkAuth: async () => {
    console.log('🔍 Checking authentication...')
    const { data: { user }, error } = await supabase.auth.getUser()

    console.log('Auth check result:', { user: user ? 'logged in' : 'not logged in', error })

    if (!user) {
      console.log('❌ User not authenticated, throwing error')
      throw new Error('Nie jesteś zalogowany')
    }

    console.log('✅ User authenticated:', user.email)
    return Promise.resolve()
  },

  checkError: (error) => {
    const status = error.status
    if (status === 401 || status === 403) {
      return Promise.reject()
    }
    return Promise.resolve()
  },

  getIdentity: async () => {
    const { data: { user } } = await supabase.auth.getUser()
    
    if (!user) {
      throw new Error('Nie jesteś zalogowany')
    }
    
    return {
      id: user.id,
      fullName: user.email || 'Użytkownik',
      avatar: user.user_metadata?.avatar_url
    }
  },

  getPermissions: () => Promise.resolve(),

  // Dodatkowa funkcja do resetowania hasła
  resetPassword: async (email: string) => {
    console.log('🔍 Sending password reset email to:', email)
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`
    })

    if (error) {
      console.error('❌ Reset password error:', error)
      throw new Error(error.message)
    }

    console.log('✅ Password reset email sent')
    return Promise.resolve()
  }
}